export const hexKey = (h) => `${h.q},${h.r}`;
export const parseHex = (key) => {
    const [q, r] = key.split(',').map(Number);
    return { q, r };
};
const DIRS = [
    { q: 1, r: 0 }, { q: 1, r: -1 }, { q: 0, r: -1 },
    { q: -1, r: 0 }, { q: -1, r: 1 }, { q: 0, r: 1 },
];
export const hexNeighbors = (h) => DIRS.map((d) => ({ q: h.q + d.q, r: h.r + d.r }));
export const hexDistance = (a, b) => {
    const dq = a.q - b.q, dr = a.r - b.r;
    return Math.max(Math.abs(dq), Math.abs(dr), Math.abs(dq + dr));
};
/** All hexes within `radius` of the origin, spiral order (origin first). */
export function hexDisk(radius) {
    const out = [];
    for (let q = -radius; q <= radius; q++) {
        for (let r = Math.max(-radius, -q - radius); r <= Math.min(radius, -q + radius); r++)
            out.push({ q, r });
    }
    return out.sort((a, b) => hexDistance(a, { q: 0, r: 0 }) - hexDistance(b, { q: 0, r: 0 }) || a.q - b.q || a.r - b.r);
}
/** Ring index (0 = centre). */
export const hexRing = (h) => hexDistance(h, { q: 0, r: 0 });
// Regions are 7-hex flowers. Their centres form a lattice generated by (3,-1) and (1,2)
// in axial coordinates (determinant 7, neighbouring centres at distance 3).
const G1 = { q: 3, r: -1 };
const G2 = { q: 1, r: 2 };
function latticePoint(a, b) {
    return { q: a * G1.q + b * G2.q, r: a * G1.r + b * G2.r };
}
/** Centre of the 7-hex region containing `h`. */
export function regionCenter(h) {
    const a0 = (2 * h.q - h.r) / 7;
    const b0 = (h.q + 3 * h.r) / 7;
    let best = latticePoint(Math.round(a0), Math.round(b0));
    let bestD = hexDistance(h, best);
    for (let da = -1; da <= 1; da++) {
        for (let db = -1; db <= 1; db++) {
            const c = latticePoint(Math.round(a0) + da, Math.round(b0) + db);
            const d = hexDistance(h, c);
            if (d < bestD) {
                best = c;
                bestD = d;
            }
        }
    }
    return best;
}
export const regionKey = (h) => `R${hexKey(regionCenter(h))}`;
/** Pixel centre of a flat-top hex of the given size (sector edge length). */
export function hexToPixel(h, size) {
    return { x: size * 1.5 * h.q, y: size * Math.sqrt(3) * (h.r + h.q / 2) };
}
//# sourceMappingURL=hex.js.map